package streetlight.model.ui

object FrontDeskRoute: StreetlightRoute {
    override val screen get() = Screen.Feedback
    override val title get() = "Feedback"
}